import React, { useEffect } from 'react'
import CenterStage from '../../Components/CenterStage/CenterStage';
import imaStage from '../../assets/AnnualReport/StageImage.jpg'
import FeatureCardCarousel from '../../Components/FeaturesCardCarousal/FeatureCardCarousal';
import imgMark from '../../assets/check-circle.svg'
import SectionHeader from '../../Components/SectionHeader/SectionHeader';
import FullImageCarousel from '../../Components/FullImageCarousel/FullImageCarousel';
import ima360Hydraulics from '../../assets/AnnualReport/Hydraulics360.jpg'
import ImageDescription from '../../Components/ImageDescription/ImageDescription';
import imaContinentsMap from '../../assets/AnnualReport/continentsMap2025.png'
import imaSalesDevelopment from '../../assets/AnnualReport/salesDevelopment2025.png'
import TextCaption from '../../Components/TextCaption/TextCaption';
import SalesShareChart from '../../Components/SalesShareChart/SalesShareChart';
import imaGraph3 from '../../assets/AnnualReport/graph3.png'
import ImageText from '../../Components/ImageText/ImageText';
import imaBottonCard from '../../assets/AnnualReport/bottomCard.jpg'


const AnnualReport = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);

    const featuresData = [
        {
            title: "5,210",
            description: "Employees",
            image: imgMark,
            model: 2
        },
        {
            title: "471",
            description: "Branches",
            image: imgMark,
            model: 2
        },
        {
            title: "429",
            description: "Service vehicles",
            image: imgMark,
            model: 2
        },
        {
            title: "43",
            description: "Countries",
            image: imgMark,
            model: 2
        },
    ]
    const featuresData2 = [
        {
            title: "€633 million",
            description: "Sales (Group, consolidated)",
            image: imgMark,
            model: 2
        },
        {
            title: "20.3%",
            description: "Risk ratio",
            image: imgMark,
            model: 2
        },
        {
            title: "80,069",
            description: "Mobile hydraulic service attendances",
            image: imgMark,
            model: 2
        },
    ]

    // Sales share by product group 2025 (unconsolidated), clockwise starting with hose assemblies
    const salesShareData = [
        { label: "Hose assemblies", value: 34.1, color: '#000000' },
        { label: "Hoses, hose technology & accessories", value: 23.9, color: '#2f3437' },
        { label: "Fittings & adapters", value: 11.6, color: '#484d50' },
        { label: "Services", value: 7.9, color: '#5f6467' },
        { label: "Couplings & ball valves", value: 4.7, color: '#80868a' },
        { label: "Hydraulic components", value: 3.5, color: '#969b9e' },
        { label: "Metal hoses", value: 3.5, color: '#a9adb0' },
        { label: "Power unit construction", value: 3.2, color: '#babec1' },
        { label: "Pipes & pipelines", value: 2.9, color: '#c8cbcd' },
        { label: "Machining", value: 2.2, color: '#d3d6d8' },
        { label: "Pneumatics", value: 0.7, color: '#dcdfe0' },
        { label: "Other", value: 1.9, color: '#e6e8e9' },
    ]

    const carouselData = [
        {
            imageSrc: ima360Hydraulics,
            title: '360° HYDRAULICS',
            subtitle: 'HANSA-FLEX offers a 360° full service for the planning, operation and optimization of mobile and stationary hydraulic systems. Our customers from all industries and sizes receive the entire range of hydraulics from us at all times:',
            listItems: ["Production of hose lines and hose management", "Repairs, Maintenance and servicing for mobile and stationary hydraulics", "Assembly services", "Spare parts trade - online and stationary", "OEM equipment, series production, production plants", "Product development & manufacturing", "Logistics and services", "Planning and technical conception", "Training, technical advice, quality assurance", "Environmentally sound disposal of old hose lines"],
        },
    ]

    const carouselData2 = [
        {
            imageSrc: imaBottonCard,
            title: 'The HANSA-FLEX ANNUAL REPORTS',
            subtitle: 'Here you can download all annual reports from 2017 to 2025.',
            model: 2,
            listItems: [
                {
                    text: "Annual Report 2025",
                    link: "/PDF_folder/AnnualReport/2025.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2024",
                    link: "/PDF_folder/AnnualReport/2024.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2023",
                    link: "/PDF_folder/AnnualReport/2023.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2022",
                    link: "/PDF_folder/AnnualReport/2022.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2021",
                    link: "/PDF_folder/AnnualReport/2021.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2020",
                    link: "/PDF_folder/AnnualReport/2020.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2019",
                    link: "/PDF_folder/AnnualReport/2019.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2018",
                    link: "/PDF_folder/AnnualReport/2018.pdf"  // Will be detected as PDF link
                },
                {
                    text: "Annual Report 2017",
                    link: "/PDF_folder/AnnualReport/2017.pdf"  // Will be detected as PDF link
                },
            ]
        },
    ]

    return (
        <div>
            <CenterStage title={"HANSA-FLEX AT A GLANCE"}
                paragraph={"HANSA-FLEX is a global family business and one of the world's leading system partners for fluid technology. In the past financial year, more than 5,210 employees in 43 countries generated sales of 633 million euros. The 2025 financial year and the key facts about HANSA-FLEX AG summarized in just a few pages: Our annual report offers a quick insight and many compact graphics."}
                buttonName={"TO THE 2025 ANNUAL REPORT"}
                buttonLink={"/PDF_folder/AnnualReport/2025.pdf"}
                imageSrc={imaStage} />

            <div className='div-gray'>
                <SectionHeader title={"HANSA-FLEX IN FIGURES"}
                    subtitle={"Here you will find the most important facts and figures about HANSA-FLEX AG from the 2025 financial year."} />
                <FeatureCardCarousel featuresData={featuresData} layout="grid" columns={4} />
            </div>
            <FeatureCardCarousel featuresData={featuresData2} layout="grid" columns={3} />

            <FullImageCarousel carouselItems={carouselData} />

            <SectionHeader title={"AT HOME ON EVERY CONTINENT"}
                subtitle={"The HANSA-FLEX locations"}
            />
            <ImageDescription
                imageSrc={imaContinentsMap}
            />
            <TextCaption title={"43 countries with 471 locations"}
                paragraph={"In addition to our own locations, we work with established partners in many other countries and deliver our goods almost anywhere you want."}
                buttonName={"BRANCH SEARCH"}
                buttonLink={"/"}
            />
            <br /><br />

            <div className='div-gray'>
                <SectionHeader title={"REVENUE DEVELOPMENT OF THE HANSA-FLEX GROUP 2021–2025"} />
                <ImageDescription
                    imageSrc={imaSalesDevelopment}
                />
                <TextCaption
                    paragraph={"Group consolidated (red), HANSA-FLEX Germany (unconsolidated, light grey), International HANSA-FLEX companies (unconsolidated, dark grey)"}
                />
                <br />
            </div>

            <SectionHeader title={"SALES SHARE BY PRODUCT GROUP AND GLOBAL SALES DISTRIBUTION"}
                subtitle={"Sales distribution unconsolidated"}
            />
            <SalesShareChart data={salesShareData} startAngle={111} />

            <div className='div-gray'>
                <FullImageCarousel carouselItems={carouselData2} />
            </div>
        </div>
    )
}

export default AnnualReport